import * as React from "react";
import { memo } from "react";
const SvgSquareButtonBg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 34, height: 35, viewBox: "0 0 34 35", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M32.381 33.4444L0 35L0.809528 -2.91748e-06L34 0.777779L32.381 33.4444Z", fill: "currentColor" }));
const Memo = memo(SvgSquareButtonBg);
export default Memo;
